/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpsertAssetPositionRestrictionOptions,
  UpsertAssetPositionRestrictionStatus200,
  UpsertAssetPositionRestrictionStatus400,
  UpsertAssetPositionRestrictionStatus500,
} from '../types/UpsertAssetPositionRestriction'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { upsertAssetPositionRestriction } from '../clients/upsertAssetPositionRestriction'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const upsertAssetPositionRestrictionMutationKey = () =>
  [{ url: '/v1/assets/:asset_id/restrictions' }] as const

export function upsertAssetPositionRestrictionMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = upsertAssetPositionRestrictionMutationKey()
  return mutationOptions<
    UpsertAssetPositionRestrictionStatus200,
    ResponseErrorConfig<
      UpsertAssetPositionRestrictionStatus400 | UpsertAssetPositionRestrictionStatus500
    >,
    UpsertAssetPositionRestrictionOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return upsertAssetPositionRestriction({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Admin only. Caps the USD value of the position any user may hold open in the given asset, counting available, locked, impending borrow and borrowed balances across the user's global and isolated accounts. The cap is the same for every tenant. A limit of 0 lifts the cap, so there is no delete. A separate limit may be set for trading challenge participants and for everyone else; applied_to_challenges selects which one is written.
 * @summary Set the open position size limit for one asset.
 * {@link /v1/assets/:asset_id/restrictions}
 */
export function useUpsertAssetPositionRestriction<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpsertAssetPositionRestrictionStatus200,
      ResponseErrorConfig<
        UpsertAssetPositionRestrictionStatus400 | UpsertAssetPositionRestrictionStatus500
      >,
      UpsertAssetPositionRestrictionOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? upsertAssetPositionRestrictionMutationKey()

  const baseOptions = upsertAssetPositionRestrictionMutationOptions(config) as UseMutationOptions<
    UpsertAssetPositionRestrictionStatus200,
    ResponseErrorConfig<
      UpsertAssetPositionRestrictionStatus400 | UpsertAssetPositionRestrictionStatus500
    >,
    UpsertAssetPositionRestrictionOptions,
    TContext
  >

  return useMutation<
    UpsertAssetPositionRestrictionStatus200,
    ResponseErrorConfig<
      UpsertAssetPositionRestrictionStatus400 | UpsertAssetPositionRestrictionStatus500
    >,
    UpsertAssetPositionRestrictionOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpsertAssetPositionRestrictionStatus200,
    ResponseErrorConfig<
      UpsertAssetPositionRestrictionStatus400 | UpsertAssetPositionRestrictionStatus500
    >,
    UpsertAssetPositionRestrictionOptions,
    TContext
  >
}
